import {
  BusinessLineSalesItemOptionModel,
  IProactiveRxRuleFormData,
} from '@common/models';
import { groupByMap } from '@common/utils';

export const groupSalesItems = (
  traitId: number | undefined,
  speciesId: number | undefined,
  sourceSelectedSalesItemOptionIds: number[] | undefined,
  salesItemOptions: BusinessLineSalesItemOptionModel[],
  isVetContext: boolean = false,
  vetSelectedSalesItemOptionIds?: number[],
) => {
  const sourceSelectedIds = new Set(sourceSelectedSalesItemOptionIds);
  const vetSelectedIds =
    vetSelectedSalesItemOptionIds && vetSelectedSalesItemOptionIds.length > 0
      ? new Set(vetSelectedSalesItemOptionIds)
      : null;

  return groupByMap(
    salesItemOptions.filter(
      (r) => r.traitId === traitId && r.speciesId === speciesId,
    ),
    (sio) => sio.salesItemId,
    (salesItemId, group) => {
      const salesItemName = group[0]?.salesItemName ?? '';

      if (isVetContext) {
        const matchedOption = vetSelectedIds
          ? group.find((option) => vetSelectedIds.has(option.salesItemOptionId))
          : group.find((option) =>
              sourceSelectedIds.has(option.salesItemOptionId),
            );
        let isSelected = false;
        let isPreferred = false;

        if (vetSelectedIds) {
          isSelected = !!matchedOption;
          isPreferred = group.some((option) =>
            sourceSelectedIds.has(option.salesItemOptionId),
          );
        } else {
          isSelected = false;
          isPreferred =
            !!matchedOption &&
            sourceSelectedIds.has(matchedOption.salesItemOptionId);
        }

        return {
          salesItemName,
          isSelected,
          isPreferred,
          salesItemOptionId: !vetSelectedIds
            ? undefined
            : matchedOption?.salesItemOptionId,
          salesItemOptions: group,
        } as IProactiveRxRuleFormData;
      } else {
        const matchedSourceOption = group.find((option) =>
          sourceSelectedIds.has(option.salesItemOptionId),
        );

        return {
          salesItemName,
          isSelected: !!matchedSourceOption,
          isPreferred: false,
          salesItemOptionId: matchedSourceOption?.salesItemOptionId,
          salesItemOptions: group,
        } as IProactiveRxRuleFormData;
      }
    },
  );
};
